'use client';

import { type ReactNode } from 'react';
import { BackButton } from '@components/mobile/navigation/back-button';
import { usePageChrome } from './page-chrome-context';

export function DesktopTopBar({
  children
}: {
  organization_id?: string;
  children: ReactNode;
}) {
  const { chrome } = usePageChrome();

  if (chrome?.hideDesktopHeaderActions) {
    return (
      <header className="hidden h-[var(--app-topbar-height)] shrink-0 items-center justify-between gap-4 border-b px-7 desktop-chrome:flex">
        {chrome.backHref ? (
          <BackButton href={chrome.backHref} label={chrome.backLabel} />
        ) : (
          <span />
        )}
        <div className="flex items-center gap-1.5">{chrome.trailingAction}</div>
      </header>
    );
  }

  return (
    <header className="hidden h-[var(--app-topbar-height)] shrink-0 items-center justify-end gap-4 border-b px-7 desktop-chrome:flex">
      <div className="flex items-center gap-1">{children}</div>
    </header>
  );
}
